<script>
export default {
  computed: {
    hideForAuthPages() {
      const path = this.$route.path;
      return ["/login", "/forgot-password", "/logout"].includes(path);
    },
  },
};
</script>

<template>
  <nav v-if="!hideForAuthPages" class="ws-bottom-nav d-md-none">
    <router-link to="/work-sched/calendar" class="ws-bottom-nav__item">
      <i class="bx bx-calendar"></i>
      <span>Calendar</span>
    </router-link>
    <router-link to="/" class="ws-bottom-nav__item ws-bottom-nav__item--center">
      <span class="ws-bottom-nav__home-circle">
        <i class="bx bx-home-alt"></i>
      </span>
      <span>Home</span>
    </router-link>
    <router-link to="/work-sched/analytics" class="ws-bottom-nav__item">
      <i class="bx bx-bar-chart-alt-2"></i>
      <span>Analytics</span>
    </router-link>
  </nav>
</template>

<style scoped>
.ws-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #fff;
  border-top: 1px solid #e9ecef;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);
  padding: 6px 8px;
  z-index: 1030;
}
.ws-bottom-nav__item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: var(--bs-secondary-color, #6c757d);
  text-decoration: none;
  padding: 6px 4px;
}
.ws-bottom-nav__item i {
  font-size: 22px;
}
.ws-bottom-nav__item.router-link-active {
  color: var(--bs-primary, #F57C00);
}
.ws-bottom-nav__item--center .ws-bottom-nav__home-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--bs-primary, #F57C00);
  color: #fff;
  margin-top: -22px;
  box-shadow: 0 4px 12px rgba(245, 124, 0, 0.4);
}
.ws-bottom-nav__item--center .ws-bottom-nav__home-circle i {
  font-size: 22px;
}
</style>
